import { render, staticRenderFns } from "./MemoryComponent.vue?vue&type=template&id=3bb37cb2&scoped=true&"
import script from "./MemoryComponent.vue?vue&type=script&lang=js&"
export * from "./MemoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemoryComponent.vue?vue&type=style&index=0&id=3bb37cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb37cb2",
  null
  
)

export default component.exports